import {
  ESIGN_LIST,
  ESIGN_LIST_SUCCESS,
  ESIGN_LIST_FAILURE,
  ESIGN_DATA,
  ESIGN_DATA_SUCCESS,
  ESIGN_DATA_FAILURE,
  ESIGN_CREATE,
  ESIGN_CREATE_SUCCESS,
  ESIGN_CREATE_FAILURE,
  ESIGN_UPDATE,
  ESIGN_UPDATE_SUCCESS,
  ESIGN_UPDATE_FAILURE,
  ESIGN_DOCUMENT_UPLOAD,
  ESIGN_DOCUMENT_UPLOAD_SUCCESS,
  ESIGN_DOCUMENT_UPLOAD_FAILURE,
  ESIGN_SEND,
  ESIGN_SEND_SUCCESS,
  ESIGN_SEND_FAILURE,
  ESIGN_VOID,
  ESIGN_VOID_SUCCESS,
  ESIGN_VOID_FAILURE,
  ESIGN_DOWNLOAD,
  ESIGN_DOWNLOAD_SUCCESS,
  ESIGN_DOWNLOAD_FAILURE,
  ESIGN_DELETE,
  ESIGN_DELETE_SUCCESS,
  ESIGN_DELETE_FAILURE,
} from "./actionType";

const initialValue = {
  esignList: [],
  esignListLoading: false,
  esignListError: null,

  esignData: [],
  esignDataLoading: false,
  esignDataError: null,

  esignCreate: [],
  esignCreateLoading: false,
  esignCreateError: null,

  esignUpdate: [],
  esignUpdateLoading: false,
  esignUpdateError: null,

  esignDocumentUpload: [],
  esignDocumentUploadLoading: false,
  esignDocumentUploadError: null,

  esignSend: [],
  esignSendLoading: false,
  esignSendError: null,

  esignVoid: [],
  esignVoidLoading: false,
  esignVoidError: null,

  esignDownload: [],
  esignDownloadLoading: false,
  esignDownloadError: null,

  esignDelete: [],
  esignDeleteLoading: false,
  esignDeleteError: null,
};

const ESign = (state = initialValue, action) => {
  switch (action.type) {
    // List
    case ESIGN_LIST:
      return {
        ...state,
        esignListLoading: true,
        esignListError: null,
      };
    case ESIGN_LIST_SUCCESS:
      return {
        ...state,
        esignList: action.payload,
        esignListLoading: false,
      };
    case ESIGN_LIST_FAILURE:
      return {
        ...state,
        esignListLoading: false,
        esignListError: action.payload,
      };

    // Data (full nested bundle)
    case ESIGN_DATA:
      return {
        ...state,
        esignDataLoading: true,
        esignDataError: null,
      };
    case ESIGN_DATA_SUCCESS:
      return {
        ...state,
        esignData: action.payload,
        esignDataLoading: false,
      };
    case ESIGN_DATA_FAILURE:
      return {
        ...state,
        esignDataLoading: false,
        esignDataError: action.payload,
      };

    // Create
    case ESIGN_CREATE:
      return {
        ...state,
        esignCreateLoading: true,
        esignCreateError: null,
      };
    case ESIGN_CREATE_SUCCESS:
      return {
        ...state,
        esignCreate: action.payload,
        esignCreateLoading: false,
      };
    case ESIGN_CREATE_FAILURE:
      return {
        ...state,
        esignCreateLoading: false,
        esignCreateError: action.payload,
      };

    // Update
    case ESIGN_UPDATE:
      return {
        ...state,
        esignUpdateLoading: true,
        esignUpdateError: null,
      };
    case ESIGN_UPDATE_SUCCESS:
      return {
        ...state,
        esignUpdate: action.payload,
        esignUpdateLoading: false,
      };
    case ESIGN_UPDATE_FAILURE:
      return {
        ...state,
        esignUpdateLoading: false,
        esignUpdateError: action.payload,
      };

    // Document upload
    case ESIGN_DOCUMENT_UPLOAD:
      return {
        ...state,
        esignDocumentUploadLoading: true,
        esignDocumentUploadError: null,
      };
    case ESIGN_DOCUMENT_UPLOAD_SUCCESS:
      return {
        ...state,
        esignDocumentUpload: action.payload,
        esignDocumentUploadLoading: false,
      };
    case ESIGN_DOCUMENT_UPLOAD_FAILURE:
      return {
        ...state,
        esignDocumentUploadLoading: false,
        esignDocumentUploadError: action.payload,
      };

    // Send
    case ESIGN_SEND:
      return {
        ...state,
        esignSendLoading: true,
        esignSendError: null,
      };
    case ESIGN_SEND_SUCCESS:
      return {
        ...state,
        esignSend: action.payload,
        esignSendLoading: false,
      };
    case ESIGN_SEND_FAILURE:
      return {
        ...state,
        esignSendLoading: false,
        esignSendError: action.payload,
      };

    // Void
    case ESIGN_VOID:
      return {
        ...state,
        esignVoidLoading: true,
        esignVoidError: null,
      };
    case ESIGN_VOID_SUCCESS:
      return {
        ...state,
        esignVoid: action.payload,
        esignVoidLoading: false,
      };
    case ESIGN_VOID_FAILURE:
      return {
        ...state,
        esignVoidLoading: false,
        esignVoidError: action.payload,
      };

    // Download
    case ESIGN_DOWNLOAD:
      return {
        ...state,
        esignDownloadLoading: true,
        esignDownloadError: null,
      };
    case ESIGN_DOWNLOAD_SUCCESS:
      return {
        ...state,
        esignDownload: action.payload,
        esignDownloadLoading: false,
      };
    case ESIGN_DOWNLOAD_FAILURE:
      return {
        ...state,
        esignDownloadLoading: false,
        esignDownloadError: action.payload,
      };

    // Delete
    case ESIGN_DELETE:
      return {
        ...state,
        esignDeleteLoading: true,
        esignDeleteError: null,
      };
    case ESIGN_DELETE_SUCCESS:
      return {
        ...state,
        esignDelete: action.payload,
        esignDeleteLoading: false,
      };
    case ESIGN_DELETE_FAILURE:
      return {
        ...state,
        esignDeleteLoading: false,
        esignDeleteError: action.payload,
      };

    default:
      return state;
  }
};

export default ESign;
